import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { isAddress } from 'utils'
import axios from 'axios'
import { API_POOL_BASE_URL } from 'constants/links'
import { useActiveWeb3React } from 'hooks'
import { useETHBalances } from 'state/wallet/hooks'

export const REFERRAL_FOR_USERS_PARAMS = 'referral'
const REFERRAL_EXPIRATION_FOR_USERS_MS = 9999 * 60 * 1000
const MINIMUM_ETH_REQUIRED_TO_BE_REFERRED = 0.1

const removeReferral = () => {
  localStorage.removeItem(REFERRAL_FOR_USERS_PARAMS)
  localStorage.removeItem(`${REFERRAL_FOR_USERS_PARAMS}_timestamp`)
  localStorage.removeItem(`${REFERRAL_FOR_USERS_PARAMS}_expiration_ms`)
}

export default function ReferralHandler() {
  const location = useLocation()
  const history = useHistory()
  const { account } = useActiveWeb3React()
  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  const walletIsNotEmpty = parseFloat(userEthBalance?.toExact() || '0') >= MINIMUM_ETH_REQUIRED_TO_BE_REFERRED

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const referralForUser = urlParams.get(REFERRAL_FOR_USERS_PARAMS)

    const usedReferral = referralForUser
    const usedExpirationTime = REFERRAL_EXPIRATION_FOR_USERS_MS

    const storedReferral = localStorage.getItem(REFERRAL_FOR_USERS_PARAMS)
    const storedTimestamp = localStorage.getItem(`${REFERRAL_FOR_USERS_PARAMS}_timestamp`)
    const storedReferralExpirationMs = localStorage.getItem(`${REFERRAL_FOR_USERS_PARAMS}_expiration_ms`)

    if (storedReferral && storedTimestamp && storedReferralExpirationMs) {
      const elapsedTime = Date.now() - parseInt(storedTimestamp, 10)
      if (elapsedTime > parseInt(storedReferralExpirationMs)) {
        removeReferral()
      }

      // post referred if wallet is not empty
      if (walletIsNotEmpty) {
        axios
          .post(`${API_POOL_BASE_URL}/api/signature/ref`, {
            referrer: storedReferral,
            user: account,
          })
          .then((response) => {
            console.log(response)
            removeReferral()
            urlParams.delete('referral')

            history.replace({
              pathname: location.pathname,
              search: urlParams.toString(),
            })
          })
          .catch((error: any) => {
            if (error?.response?.data?.message === 'User already referred') {
              removeReferral()
              urlParams.delete('referral')

              history.replace({
                pathname: location.pathname,
                search: urlParams.toString(),
              })
            }
            console.error('Error posting referred', error)
          })
      }
    }

    const storeReferral = (address: string) => {
      if (address !== account) {
        localStorage.setItem(REFERRAL_FOR_USERS_PARAMS, address)
        localStorage.setItem(`${REFERRAL_FOR_USERS_PARAMS}_timestamp`, Date.now().toString())
        localStorage.setItem(`${REFERRAL_FOR_USERS_PARAMS}_expiration_ms`, `${usedExpirationTime}`)
      }
    }

    if (usedReferral) {
      if (isAddress(usedReferral)) {
        storeReferral(usedReferral)
      } else {
        axios
          .get(`${API_POOL_BASE_URL}/api/signature/get-id`, {
            params: { address: usedReferral },
          })
          .then((response) => {
            const evmAddress = response.data?.address
            if (evmAddress && isAddress(evmAddress)) {
              storeReferral(evmAddress)
            }
          })
          .catch((error: any) => {
            console.error('Error fetching EVM address:', error)
          })
      }
    }
  }, [location.search, walletIsNotEmpty, account, location.pathname, history])

  return null
}
